module.exports = __webpack_public_path__ + "static/giant_vulture-49a5a8860e8a90e8782bfd6d8a6b0e5e.jpg";